import React from 'react';
import { Link } from 'react-router-dom';
import { Flower, MapPin, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-stone-900 text-stone-300 py-12 border-t-4 border-saffron-600 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <img src="/images/nathnagri-bareilly-logo.png" alt="Nathnagri Bareilly Logo" className="h-10 w-auto brightness-0 invert opacity-80" />
              <span className="font-bold text-xl text-white tracking-tight">
                नाथ नगरी <span className="text-saffron-500 font-medium">मंदिर</span>
              </span>
            </Link>
            <p className="text-sm text-stone-400 mb-6 leading-relaxed">
              बरेली के सात प्राचीन नाथ मंदिरों का अन्वेषण करें। हमारे शहर की आध्यात्मिक शांति, समृद्ध इतिहास और जीवंत भक्ति की खोज करें।
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-stone-400 hover:text-saffron-400 transition-colors">Facebook</a>
              <a href="#" className="text-stone-400 hover:text-saffron-400 transition-colors">Twitter</a>
              <a href="#" className="text-stone-400 hover:text-saffron-400 transition-colors">Instagram</a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">महत्वपूर्ण लिंक</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-saffron-400 transition-colors duration-200">होम</Link></li>
              <li><Link to="/temples" className="hover:text-saffron-400 transition-colors duration-200">सभी मंदिर</Link></li>
              <li><Link to="/blog" className="hover:text-saffron-400 transition-colors duration-200">ब्लॉग</Link></li>
              <li><Link to="/forum" className="hover:text-saffron-400 transition-colors duration-200">सामुदायिक मंच</Link></li>
              <li><Link to="/polls" className="hover:text-saffron-400 transition-colors duration-200">सक्रिय मतदान</Link></li>
            </ul>
          </div>

          {/* Information */}
          <div>
            <h3 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">जानकारी</h3>
            <ul className="space-y-2">
              <li><a href="#" className="hover:text-saffron-400 transition-colors duration-200">हमारे बारे में</a></li>
              <li><a href="#" className="hover:text-saffron-400 transition-colors duration-200">गोपनीयता नीति</a></li>
              <li><a href="#" className="hover:text-saffron-400 transition-colors duration-200">सेवा की शर्तें</a></li>
            </ul>
          </div>

          {/* Contact Details */}
          <div>
            <h3 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">संपर्क करें</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-saffron-500 mt-0.5" />
                <span className="text-sm">बरेली शहर, उत्तर प्रदेश<br/>243001, भारत</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-saffron-500" />
                <span className="text-sm">+91 (123) 456-7890</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-saffron-500" />
                <span className="text-sm">info@nathnagribareilly.com</span>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-stone-800 mt-12 pt-8 text-center sm:flex sm:justify-between sm:text-left">
          <p className="text-sm text-stone-500">
            &copy; {new Date().getFullYear()} नाथ नगरी मंदिर. सर्वाधिकार सुरक्षित।
          </p>
          <p className="text-sm text-stone-500 mt-2 sm:mt-0 flex items-center justify-center">
            भगवान शिव को समर्पित
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
